<script lang="ts">
  import { css, cx } from '@agapi/ui/panda/css';
  import { cardStyles } from '../card.styles';
  import type { CardOverlayProps } from '../card.types';

  const { css: cssProp, children, ...props }: CardOverlayProps = $props();

  const classes = cardStyles()
</script>

<div class={cx(classes.container, css(cssProp))} {...props}>
  {@render children?.()}
</div>
